
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BNYSCoursePage: React.FC = () => {
  const courseData = {
    title: "BNYS - Bachelor of Naturopathy & Yoga Sciences",
    shortName: "BNYS",
    duration: "5.5 years (4.5 years + 1 year internship)",
    description: "Natural healing and wellness through naturopathy, yoga, and holistic health practices",
    overview: "Bachelor of Naturopathy & Yoga Sciences (BNYS) is an undergraduate medical degree that focuses on natural healing methods, yoga therapy, and holistic wellness approaches. This course trains students to diagnose and treat diseases using natural remedies, lifestyle modifications, yoga practices, and drug-free therapeutic interventions based on the body's inherent healing capacity.",
    eligibility: [
      "10+2 with Physics, Chemistry, Biology",
      "Minimum 50% marks (40% for SC/ST)",
      "NEET qualification mandatory",
      "Age: 17-25 years"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Anatomy",
          "Physiology",
          "Biochemistry",
          "Philosophy of Naturopathy",
          "History & Principles of Naturopathy",
          "Yoga Philosophy & Practice"
        ]
      },
      {
        year: 2,
        subjects: [
          "Pathology",
          "Microbiology",
          "Pharmacology",
          "Naturopathic Nutrition",
          "Yoga Therapy",
          "Psychology & Counseling"
        ]
      },
      {
        year: 3,
        subjects: [
          "Naturopathic Medicine",
          "Yoga & Physical Therapy",
          "Diagnostic Methods",
          "Fasting Therapy",
          "Hydrotherapy",
          "Mud Therapy & Natural Treatments"
        ]
      },
      {
        year: 4,
        subjects: [
          "Clinical Naturopathy",
          "Advanced Yoga Therapy",
          "Panchakosha Theory",
          "Lifestyle Counseling",
          "Research Methodology",
          "Community Health & Preventive Medicine"
        ]
      },
      {
        year: 5,
        subjects: [
          "Clinical Training",
          "Internship in Naturopathy Hospitals",
          "Patient Case Management",
          "Research Project",
          "Yoga Teaching Practice",
          "Public Health Programs"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Naturopathy Doctor",
        "Yoga Therapist",
        "Wellness Consultant",
        "Lifestyle Coach",
        "Naturopathy Medical Officer",
        "Research Scientist",
        "Spa & Wellness Center Manager",
        "Nutrition Counselor",
        "Fitness & Wellness Trainer",
        "Alternative Medicine Practitioner"
      ],
      industries: [
        "Naturopathy Hospitals",
        "Wellness Centers",
        "Yoga Institutes",
        "Spa & Resort Industry",
        "Corporate Wellness",
        "Sports Medicine",
        "Government Health Departments",
        "NGOs",
        "Fitness Centers",
        "Health Tourism"
      ],
      averageSalary: "₹3-8 LPA",
      topRecruiters: [
        "Government Naturopathy Hospitals",
        "Wellness Resorts",
        "Corporate Wellness Programs",
        "Yoga Centers",
        "Sports Organizations",
        "Health Retreats"
      ]
    },
    topColleges: [
      {
        name: "SDM College of Naturopathy & Yogic Sciences",
        location: "Ujire, Karnataka",
        fees: "₹75,000/year",
        ranking: "9.2/10"
      },
      {
        name: "Rajiv Gandhi University of Health Sciences",
        location: "Bangalore, Karnataka",
        fees: "₹60,000/year",
        ranking: "8.9/10"
      },
      {
        name: "JSS Institute of Naturopathy & Yogic Sciences",
        location: "Coimbatore, Tamil Nadu",
        fees: "₹80,000/year",
        ranking: "8.7/10"
      },
      {
        name: "Government Yoga & Naturopathy Medical College",
        location: "Chennai, Tamil Nadu",
        fees: "₹25,000/year",
        ranking: "8.5/10"
      },
      {
        name: "Anushka College of Naturopathy",
        location: "Hyderabad, Telangana",
        fees: "₹55,000/year",
        ranking: "8.3/10"
      }
    ],
    skills: [
      "Natural Healing Techniques",
      "Yoga Therapy & Asanas",
      "Meditation & Mindfulness",
      "Nutritional Counseling",
      "Hydrotherapy Techniques",
      "Mud & Clay Therapy",
      "Lifestyle Modification",
      "Stress Management",
      "Holistic Health Assessment",
      "Patient Education & Counseling"
    ],
    futureScope: "Growing global wellness industry, increasing focus on preventive healthcare, corporate wellness programs expansion, yoga and meditation popularity worldwide, government support for traditional healing systems, integration with modern healthcare, wellness tourism growth, fitness industry collaboration, and research opportunities in natural healing methods.",
    faqs: [
      {
        question: "Is BNYS a recognized medical degree?",
        answer: "Yes, BNYS is a recognized medical degree under the Central Council of Indian Medicine (CCIM) and Ministry of AYUSH, Government of India."
      },
      {
        question: "Can BNYS graduates prescribe medicines?",
        answer: "BNYS practitioners primarily use natural therapies and lifestyle interventions. They focus on drug-free healing methods rather than pharmaceutical prescriptions."
      },
      {
        question: "What is the difference between BNYS and other yoga certifications?",
        answer: "BNYS is a comprehensive medical degree covering naturopathy and yoga therapy, while yoga certifications are typically shorter courses focused only on yoga teaching."
      },
      {
        question: "Is NEET required for BNYS admission?",
        answer: "Yes, NEET is mandatory for admission to BNYS courses in all recognized naturopathy and yoga medical colleges."
      },
      {
        question: "What career opportunities are available after BNYS?",
        answer: "Graduates can work as naturopathy doctors, yoga therapists, wellness consultants, in government health departments, wellness centers, and can also start private practice."
      },
      {
        question: "Can I pursue higher studies after BNYS?",
        answer: "Yes, you can pursue MD (Naturopathy) or specialized courses in yoga therapy, nutrition, and wellness management."
      }
    ],
    admissionProcess: [
      "NEET Qualification",
      "State/National Counseling Registration",
      "Choice Filling & Document Verification",
      "Seat Allotment",
      "College Reporting & Fee Payment"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BNYSCoursePage;
